import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=0e565ae1&scoped=true"
import script from "./Row.vue?vue&type=script&lang=ts"
export * from "./Row.vue?vue&type=script&lang=ts"
import style0 from "./Row.vue?vue&type=style&index=0&id=0e565ae1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e565ae1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e565ae1')) {
      api.createRecord('0e565ae1', component.options)
    } else {
      api.reload('0e565ae1', component.options)
    }
    module.hot.accept("./Row.vue?vue&type=template&id=0e565ae1&scoped=true", function () {
      api.rerender('0e565ae1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/Row.vue"
export default component.exports